import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Group, Image, List, Paper, SimpleGrid, Stack, Text } from '@mantine/core';
import { IconPointFilled } from '@tabler/icons-react';
import classes from './GameIntro.module.css';
import { GameIntroListItem } from './GameIntroListItem';
export const GameIntro: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <SimpleGrid cols={{
    base: 1,
    sm: 2
  }} spacing={{
    base: 'md',
    sm: 'lg'
  }} mt="lg">
      <Card px={20} py={32} radius={5} bg="var(--bg-200)">
        <Stack gap={0} style={{
        wordBreak: 'break-word'
      }}>
          <Text fz={{
          base: 'sm',
          sm: 'lg'
        }} className={gunterzBold.className}>
            {i18n._('Why Play Sweet Bonanza on PrimeRoll?')}
          </Text>

          <List classNames={{
          itemIcon: classes.itemIcon
        }} icon={<IconPointFilled size={20} color="var(--text-prime)" />}>
            <GameIntroListItem title={i18n._('Earn wgPRLL:')} des={i18n._('For every $1 wagered, receive 1 wgPRLL to level up your PrimeRoll NFT.')} />
            <GameIntroListItem title={i18n._('VIP Rewards:')} des={i18n._('Climb the PrimeRoll VIP ranks for increased rakeback and bonuses.')} />
            <GameIntroListItem title={i18n._('Exclusive Battles:')} des={i18n._('Challenge other players in Sweet Bonanza battles for bigger prizes.')} />
            <GameIntroListItem title={i18n._('NFT Boosts:')} des={i18n._('Use your PrimeRoll NFT traits to enhance your Sweet Bonanza experience.')} />
          </List>
        </Stack>
      </Card>

      <Card px={20} py={{
      sm: 24,
      lg: 32
    }} radius={5} bg="var(--bg-200)">
        <Paper px={16} py={28} bg="var(--bg-400)">
          <Group justify="end" pos="relative">
            <Image src="/assets/headphone.svg" alt="headphone" w={{
            base: 84,
            lg: '7rem'
          }} h={{
            base: 84,
            lg: '8rem'
          }} pos="absolute" left={-10} />
            <Text w="70%" fz={{
            base: 10,
            lg: 'xs'
          }} tt="uppercase" c="var(--text-dark)" fw={700}>
              {i18n._('Remember, PrimeRoll offers ')}
              <Text span inherit c="var(--text-green)">
                {i18n._('24/7 support ')}
              </Text>
              {i18n._('if you need any assistance with deposits, withdrawals, or gameplay.')}
            </Text>
          </Group>
        </Paper>

        <Text mt={67} variant="gradient" className={gunterzBold.className} fz={{
        base: 'sm',
        sm: 'lg',
        lg: 'lg'
      }} gradient={{
        from: '#DBFE02',
        to: '#44FF66',
        deg: 135
      }}>
          {i18n._('join the sugar rush on primeroll!')}
        </Text>
        <Text mt={10} fz="xs" c="var(--text-dark)">
          {i18n._(`Experience Sweet Bonanza and other top Pragmatic Play titles while enjoying PrimeRoll's unique features. Level up your NFT, participate in battles, and climb the VIP ranks for a truly sweet gaming experience!`)}
        </Text>
      </Card>
    </SimpleGrid>;
};